<div class="card">
  <div class="card-top">
    <div class="card-top-text">
      {{ curso.Title }}
    </div>
    <div class="wave"></div>
  </div>
  <div class="card-body">
    <h2 class="card-title">{{ curso.Provider }}</h2>
    <h3>
      <span><strong>Descripción: </strong></span>
    </h3>
    <div [innerHTML]="truncatedDescripcion"></div>
    <div class="fecha">
      <h3>
        <span><strong>Fecha de Creación: </strong></span>
      </h3>
      <div>{{ curso.CreateDate | date: "dd/MM/yyyy" }}</div>
    </div>
    <div class="duracion">
      <h3>
        <span><strong>Duración: </strong>{{ curso.Duration }}</span>
      </h3>
    </div>

    <button class="btn btn-primary" (click)="openModal()">Ver Detalles</button>
  </div>
</div>
